export default __webpack_public_path__ + "static/intl-ef5c8776ed1dd0d71f2d1468db9405cf.svg";